import { Middleware, MiddlewareAPI } from 'redux';
import * as config from 'config';
import * as logger from 'logger';
import * as notificationApi from 'api/notification-api';
import * as tenantService from 'services/tenant-service';
import { LIST_NOTIFICATIONS, DISMISS_NOTIFICATION, 
  SetNotificationsAction, ListNotificationsAction, DismissNotificationAction } from './actions';
import { usernameSelector } from 'pages/user-profile/selectors';

const NotificationMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {
      case LIST_NOTIFICATIONS:
        await listNotifications(store, action);
        break;

      case DISMISS_NOTIFICATION:
        await dismissNotification(store, action);
        break;

      default:
        break;
    }
    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'OperationGridMiddleware');
  }
};

async function listNotifications(store: MiddlewareAPI, action: ListNotificationsAction): Promise<void> {
  try {
    const notifications = await notificationApi.listNewNotifications(action.tenantId, action.username, config.APPLICATION_VERSION);
    store.dispatch(new SetNotificationsAction(notifications));
  }
  catch (error) {
    logger.error(error, 'NotificationMiddleware.listNotifications');
  }
}

async function dismissNotification(store: MiddlewareAPI, action: DismissNotificationAction): Promise<void> {
  try {
    const tenantId = await tenantService.getTenantId();
    const username = usernameSelector(store.getState());
    await notificationApi.dismissNotification(action.notificationId, tenantId, username);
  }
  catch (error) {
    logger.error(error, 'NotificationMiddleware.dismissNotification');
  }
}

export default NotificationMiddleware;


// WEBPACK FOOTER //
// ./src/components/notification/middleware.ts